import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import { useState, useEffect } from 'react';
import  { useRouter } from 'next/router'
import UIDropdown from '../common/ui-components/input/UIDropdown/UIDropdown';
import UITextArea from '../common/ui-components/input/UITextArea';
import UITextField from '../common/ui-components/input/UITextField';
import { WriteToUs } from '../../api/selfserve';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { raiseQueryClick, raiseQuerySumbit, trackSR, chatWithUsModal } from '../../tracking/selfserveTracking';
import { chatbotClicked } from '../../tracking/segment/footer';
import { getPageURL } from '../../utils/tracking';
import { cleverTapTrigger } from '../../tracking/segment';


interface MainProps{
    closeModal: any,
    refNo: string,
    planDetail: any,
    is_open: boolean,
    osid?:any,
    setPageLoading?: any,
    category?: any
}
export const OpenRequestAlert = (props: MainProps) => {

    const [refNo, setRefNo] = useState('')

    useEffect(() => {

        setRefNo(props.refNo);

    }, []) 
    useEffect(()=>{
        if(props.is_open){
            cleverTapTrigger('Request Open Popup', {'osid':props.osid, 'sr_id':props.refNo, 'category': props.category, 'product_type': props.planDetail.product_type})
        }
    },[props?.is_open]) 
    const router = useRouter()
    const [raiseQuery, setRaiseQuery] = useState(false);
    const [issue, setIssue] = useState<any>(null)
    const [subIssue, setSubIssue] = useState<any>(null)
    const [comment, setComment] = useState<string>("")
    const [errorIssue, setErrorIssue] = useState<string>("")
    const [errorSubIssue, setErrorSubIssue] = useState("")
    const [issueBorder, setIBorder] = useState<boolean>(true)
    const [subIssueBorder, setSubIBorder] = useState<boolean>(true)
    const [thanks, setThanks] = useState(false)
    const [loading, setLoading] = useState(false)


    const titleText = !raiseQuery ? "Request is Open" : "Raise a Query"
    const bodyText = !raiseQuery ? (refNo  ? `We see that there is an open service request raised for the same device (SR ID: ${refNo}). Would you need any further support?` : `We see that there is an open service request raised for the same device (SR ID: ${props.refNo}). Would you need any further support?`) : "";

    const close = () => {
        // changeOpen(false)
        if(router.query.app_render){
            setRaiseQuery(false);
            setThanks(false);
            props.closeModal(false)
            props.setPageLoading(false)
        }
        else if(Object.keys(router.query).length !== 0 && router.query?.osid)
        {
            window.location.href = window.location.pathname
        }
        else
        {
            setRaiseQuery(false);
            setThanks(false);
            props.closeModal(false)
            props.setPageLoading(false)
        }
        return false
    }
    const handleRaiseQuery = () => {
        raiseQueryClick(); //gtm tracking event
        setRaiseQuery(true)
    }

    const trackRequest = () => {
        // changeOpen(false)
        trackSR(); //gtm tracking event
        const refNumber = refNo ? refNo : props.refNo
        if(router?.query?.app_render){
            router.query.sr_id = refNumber
            router.push(router)
        }else{
            window.open(`/selfserve/tracker/service-request/${refNumber}`, "noopener,noreferrer")
            window.opener = null
        }
        close()
    }

    const openChat = () => {
        chatWithUsModal('Plan Page'); //gtm tracking event
        props.closeModal(false)
        chatbotClicked({...getPageURL()})
        window.open(`https://onst.in/4dCuJA`, "noopener,noreferrer")
        window.opener = null
        setRaiseQuery(false);
        setThanks(false);
    }

    const handleSelect = (e) => {
        setErrorIssue("")
        setIBorder(true)
        setIssue(e["value"])
        return false
    }

    const handleSelectSubIssue = (e) => {
        setErrorSubIssue("")
        setSubIBorder(true)
        setSubIssue(e["value"])
        return false
    }

    const handleSelectComment = (e) => {
        setComment(e.target.value)
    }

    const handleSelectRefNo = (e) => {
        setRefNo(e.target.value)
    }

    const issueOptions: any[] = [
        {
            text: "Reopen/Concern with Open Request",
            value: "Reopen/Concern with Open Request",
            key: 1,
        },
    ]

    const subIssueOptions: any[] = [
        {
            text: "Problem is not resolved/still existing",
            value: "Problem is not resolved/still existing",
            key: 1,
        },
        {
            text: "New issues observed with previous repair",
            value: "New issues observed with previous repair",
            key: 2,
        },
        {
            text: "Cosmetic damage during the repair",
            value: "Cosmetic damage during the repair",
            key: 3,
        },
        {
            text: "Others",
            value: "Others",
            key: 4,
        },

    ]

    const onSubmit = (e) => {
        raiseQuerySumbit(); //gtm tracking event
        if (issue === null || subIssue === null) {
            if (issue === null) {
                setIBorder(false)
                setErrorIssue("Required fields")
            }
            if (subIssue === null) {
                setSubIBorder(false)
                setErrorSubIssue("Required fields")
            }
        }
        else {
            e.preventDefault()
            const subject = 'Query raised via Selfserve'
            const oldData = props.planDetail.old_data.order
            const orderData = props.planDetail.order
            const name = oldData ? oldData.old_order.name : orderData.name
            const phone = oldData ? oldData.old_order.phone : orderData.phone
            const email = oldData ? oldData.old_order.email : orderData.email
            const data: any = { 'issue': issue, 'sub_issue': subIssue, 'servicerequestno': refNo, 'name': name, 'phone': phone, 'subject': subject, 'email': email, 'comment': comment }
            setLoading(true)
            WriteToUs(data)
            setThanks(true)
            setLoading(false)
            return false
        }
    }


    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            {!raiseQuery && !thanks &&
                <div className={styles.selfserve_alert}>

                    <h5 className={styles.selfserve_alert__title}>{titleText}</h5>

                    <div className={styles.selfserve_alert__text}>
                        <p>{bodyText}</p>
                    </div>

                    <div className={commonStyles.customButton} style={{'marginTop' : "0"}}>

                        <Button
                            className={commonStyles.btn_single}
                            onClick={trackRequest}
                            text="Track Request"
                            variant="secondary"
                            style={{'marginTop' : '20px', 'fontSize': '14px'}}
                        />

                        <Button
                            className={commonStyles.btn_single}
                            onClick={handleRaiseQuery}
                            text="Raise Query/Concern"
                            variant="secondary"
                            style={{'marginTop' : '20px', 'fontSize': '14px'}}
                        />

                        <Button
                            className={`${commonStyles.btn_single} ${styles.primary_btn}`}
                            onClick={openChat}
                            text="Chat with us"
                            style={{'marginTop' : '20px', 'fontSize': '14px'}}
                        />

                    </div>
                    {/* <div className={styles.raise_query_buttons}>

                        <Button
                            className={styles.raise_query_buttons__button}
                            onClick={trackRequest}
                            text="Track Request"
                            variant="secondary"
                        />
                        <Button
                            className={styles.raise_query_buttons__button}
                            onClick={handleRaiseQuery}
                            text="Raise Query/Concern"
                            variant="secondary"
                        />
                        <Button
                            className={styles.raise_query_buttons__button}
                            onClick={openChat}
                            text="Chat with us"
                        />

                    </div> */}
                </div>
            }
            {raiseQuery && !thanks &&
                <form method="POST" action="#" className={styles.form_wrap}>
                    <h6>Raise a Query</h6>
                    <div className={styles.input_wrap}>
                        <div className={styles.selfserve_text_area}><UITextField id="ref_no" isForm={true} noLabel={false} className={`${styles.formdiv__textfield}`} type="text" isRequired={true} value={refNo ? refNo : props.refNo} label="Your SR Ref No" onChange={() => handleSelectRefNo} /></div>

                        <div className={styles.selfserve_dropdown}><UIDropdown isRequired={true} className={issueBorder ? `${styles.bordering}` : `${styles.bordering__error}`} propsError={errorIssue} options={issueOptions} selected_option={issue === null ? null : { text: issue, value: issue, key: issue }} placeholder="Select Issue" onChange={(e: React.ChangeEvent<{}>) => handleSelect(e)} /> </div>

                        <div className={styles.selfserve_dropdown}><UIDropdown isRequired={true} className={subIssueBorder ? `${styles.bordering}` : `${styles.bordering__error}`} propsError={errorSubIssue} options={subIssueOptions} selected_option={subIssue === null ? null : { text: subIssue, value: subIssue, key: subIssue }} placeholder="Select Sub-issue" onChange={(e: React.ChangeEvent<{}>) => handleSelectSubIssue(e)} /> </div>

                        <div className={styles.selfserve_text_area}>
                            <UITextArea noPlaceholder={false} label="Comments" className={`${styles.formdiv__textfield}`} value={comment} onChange={(e: any) => handleSelectComment(e)} />

                        </div>
                        <div className={commonStyles.button_actions_sticky} data-varient='non-sticky' style={{'marginTop': '20px', 'marginBottom': '43px'}}>
                            <Button
                                variant="secondary"
                                onClick={close}
                                text="Cancel"
                                className={commonStyles.cart_btn}
                                style={{'fontSize': '14px'}}
                            />
                            <Button
                                text="Submit"
                                onClick={(e: React.ChangeEvent<{}>) => onSubmit(e)}
                                loading={loading}
                                className={commonStyles.cart_btn}
                                style={{'fontSize': '14px'}}
                            />

                        </div>
                    </div>
                </form>
            }
            {thanks &&
                <div className={styles.selfserve_alert}>
                    <h5 className={styles.selfserve_alert__title}>{titleText}</h5>
                    <div className={styles.selfserve_alert__text}>
                        <p>Thank you for sharing the details with us, our team will get in touch with you shortly.</p>
                    </div>

                    <div className={commonStyles.single_button}>
                        <Button
                            onClick={close}
                            text="Ok"
                            className={commonStyles.single_btn}
                            style={{'width': '200px', 'fontSize': '14px'}}
                        />

                    </div>
                </div>
            }
        </UIModal>
    )
}
